<app-card-relatorio-laudo [titulo]="template.label" [status]="template.status">

    <div class="row justify-content-around">
        <div *ngFor="let e of template.elements" class="p-2">
            <div class="hex m-auto" [ngClass]="{
                'bg-success': e.status < 3,
                'bg-warning': e.status > 2 && e.status < 5,
                'bg-danger': e.status > 4
            }">
                <div [ngClass]="{
                    'hex-icon-success': e.status < 3,
                    'hex-icon-warning': e.status > 2 && e.status < 5,
                    'hex-icon-danger': e.status > 4
                }"></div>
            </div>
            <div class="fw-500 m-auto" [ngClass]="{
                'text-success': e.status < 3,
                'text-warning': e.status > 2 && e.status < 5,
                'text-danger': e.status > 4
            }"> {{e.label}} </div>
        </div>
    </div>

</app-card-relatorio-laudo>